import {
  Course,
  EnrolledTraining,
  Interest,
  User,
  UserAccess,
  UserGeneralStatistics,
  UserRanking,
  UserTeam
} from "../../entities/entities";
import { userProfileRepository } from "../../../infrastructure/repository/impl/userProfile_repository";
import { EventCourse } from "../../entities/courseEvent/courseEvent";
import { TrainingCourseRequest } from "../../entities/courseEvent/training_course";
import { Order } from "domain/entities/order";
import { ListResponse } from "domain/entities/shop/product/listResponse";

interface UserProfileUseCases {
  get(): Promise<User>;

  edit(user: User): Promise<void>;

  editUserInterests(interests: Interest[]): Promise<void>;

  getUserCoursesInProgress(): Promise<Course[]>;

  getUserEnrolledTraining(order: Order): Promise<EnrolledTraining[]>;

  getUserEvents(): Promise<EventCourse[]>;

  getUserEvent(eventId: number): Promise<EventCourse>;

  getUserTraining(eventId: number): Promise<TrainingCourseRequest>;

  validateUserIsLogged(): Promise<void>;

  getTeams(): Promise<UserTeam[]>;

  getUsersRanking(): Promise<UserRanking[]>;

  getGeneralStatistics(): Promise<UserGeneralStatistics>;

  getAccessesStatistics(): Promise<UserAccess[]>;

  getUserCertificate(trainingID: number): Promise<string>;

  listUsers(order: Order): Promise<ListResponse<User>>;

  indicationTrainingUser(userIDs: number[], courseID: number): Promise<number>;
}

class _UserProfileUseCases implements UserProfileUseCases {
  async get(): Promise<User> {
    return await userProfileRepository.get();
  }

  async edit(user: User): Promise<void> {
    if (user.address) {
      user.address.stateID = Number(user.address.stateID);
    }
    return await userProfileRepository.edit(user);
  }

  async editUserInterests(interests: Interest[]): Promise<void> {
    return await userProfileRepository.editUserInterests(interests);
  }

  async getUserCoursesInProgress(): Promise<Course[]> {
    return await userProfileRepository.getUserCoursesInProgress();
  }

  async getUserEnrolledTraining(order: Order): Promise<EnrolledTraining[]> {
    return await userProfileRepository.getUserEnrolledTraining(order);
  }

  async getUserEvents(): Promise<EventCourse[]> {
    return await userProfileRepository.getUserEvents();
  }

  async getUserEvent(eventId: number): Promise<EventCourse> {
    return await userProfileRepository.getUserEvent(eventId);
  }

  async getUserTraining(eventId: number): Promise<TrainingCourseRequest> {
    return await userProfileRepository.getUserTraining(eventId);
  }

  async validateUserIsLogged(): Promise<void> {
    return await userProfileRepository.validateUserIsLogged();
  }

  async getTeams(): Promise<UserTeam[]> {
    return await userProfileRepository.getTeams();
  }

  async getUsersRanking(): Promise<UserRanking[]> {
    return await userProfileRepository.getUsersRanking();
  }

  async getGeneralStatistics(): Promise<UserGeneralStatistics> {
    return await userProfileRepository.getGeneralStatistics();
  }

  async getAccessesStatistics(): Promise<UserAccess[]> {
    return await userProfileRepository.getAccessesStatistics();
  }
  async getUserCertificate(trainingID: number): Promise<string> {
    return await userProfileRepository.getUserCertificate(trainingID);
  }

  listUsers = async (order: Order): Promise<ListResponse<User>> => {
    return await userProfileRepository.listUsers(order);
  };

  indicationTrainingUser = async (userIDs: number[], courseID: number): Promise<number> => {
    return await userProfileRepository.indicationTrainingUser(userIDs, courseID);
  };
}

export const userProfileUseCases: UserProfileUseCases = new _UserProfileUseCases();
